export { default } from "./useGetVideoConfig";
